const content = "_content_o77nw_8";
const destructive = "_destructive_o77nw_34";
const success = "_success_o77nw_39";
const styles = {
  content,
  destructive,
  success
};
export {
  content,
  styles as default,
  destructive,
  success
};
//# sourceMappingURL=BigIcon.module.css.js.map
